import Logger from './lib/logger';
/* import '@ungap/custom-elements'; */
import './partials/SvgIcon';
import './partials/TrayReviewMain';
import './partials/PricingEstimate';
import './partials/NumberButton';

const NAME = 'Custom Tray Review';

function init() {
  Logger.info(`${NAME} > init`);
}

init();